<template>
  <div>
    <table
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="combined-report styled-table selectable"
    >
      <thead>
        <tr>
          <th style="min-width: 150px" class="header-title">Orgão</th>
          <th class="header-title" v-for="row in tableItems" :key="row.id">
            <span class="" v-text="row.label"></span>
          </th>
          <th class="header-title">Total</th>
        </tr>
      </thead>
      <tr v-for="(organ, key) in organs" :key="key">
        <td :key="key + 'type'">{{ organ }}</td>
        <td :key="key + 'tumural'">{{ getOrganCount(organ, true) }}</td>
        <td :key="key + 'adicional'">{{ getOrganCount(organ, false) }}</td>
        <td :key="key + 'total'">{{ getOrganTotal(organ) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    logs: { default: [] }
  },
  data() {
    return {
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
      tableItems: [
        { id: 'tumural', label: 'Patologia Tumoral' },
        { id: 'adicional', label: 'Patologia Adicional' }
      ]
    }
  },
  computed: {
    ...mapGetters(['user']),
    organs() {
      return [
        ...new Set(
          this.logs.map(l => l['pathology-diagnosis'].group).filter(ho => ho)
        )
      ]
    },
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--bg-odd-color': this.style.colors[0] + 40,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    }
  },
  methods: {
    getOrganCount(organ, tumoral) {
      return this.logs.filter(
        l =>
          l['pathology-diagnosis'].group === organ &&
          l['pathology-diagnosis'].tumoral === tumoral
      ).length
    },
    getOrganTotal(organ) {
      return this.logs.filter(l => l['pathology-diagnosis'].group === organ)
        .length
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  }
}
</script>

<style>
.styled-table {
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  border-collapse: var(--border-collapse);
}
.styled-table.bordered td,
.styled-table.bordered thead {
  border-bottom: 1px solid var(--border-color);
}
.styled-table.bordered tr td,
.styled-table.bordered thead th {
  border-right: 1px solid var(--accent-border-color);
}
.styled-table.bordered tr td:last-child,
.styled-table.bordered thead th:last-child {
  border-right: none;
}
.categ-title {
  background-color: var(--categ-color) !important;
  width: 20px;
  font-weight: bold;
}
.subcateg-title {
  background-color: var(--subcateg-color) !important;
}
.rotate-text {
  writing-mode: vertical-lr;
  -ms-writing-mode: tb-rl;
  transform: rotate(180deg);
}
.combined-report thead th.header-title {
  background-color: var(--categ-color) !important;
}
.combined-report thead th.total {
  background-color: var(--bg-color) !important;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
  vertical-align: middle;
}

.odd {
  background-color: var(--bg-odd-color);
}
.even {
  background-color: var(--bg-light-color);
}

tr.total td {
  background-color: var(--bg-odd-color);
}
tr.total td.odd {
  background-color: var(--subcateg-color);
}
.styled-table td.total {
  background-color: var(--subcateg-color);
  font-weight: bold;
  min-width: 70px;
}
.total-cell {
  background-color: var(--categ-color) !important;
  font-weight: bold;
}

.styled-table tr:last-of-type {
  border-bottom: 1px solid var(--border-color);
}
</style>
